import { Link } from "react-router-dom";

export default function ExtraSection() {
  return (
    <section className="my-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Books Card */}
        <div className="group glassmorphism rounded-3xl p-8 flex flex-col justify-between hover:-translate-y-2 hover:shadow-2xl transition duration-500 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-32 h-32 bg-main/10 rounded-full blur-2xl pointer-events-none transition duration-500 group-hover:bg-main/20"></div>
          <div>
            <h3 className="text-2xl font-bold font-Philosopher text-heads mb-6 flex items-center gap-3">
              <span className="text-accent">📚</span> Our Literature
            </h3>
            <div className="relative overflow-hidden rounded-xl mb-8 group-hover:shadow-xl transition duration-500 flex justify-center bg-white/30 backdrop-blur-sm p-4 border border-white/50">
              <img
                src={require("../assets/Arth Panchak Siddhant.jpg")}
                className="h-56 object-contain transform transition duration-500 group-hover:scale-105 drop-shadow-xl"
                alt="Arth Panchak Siddhant"
              />
            </div>
            <p className="text-heads/70 font-medium mb-8">
              Explore the profound wisdom and divine teachings through our
              curated collection of books and literature.
            </p>
          </div>
          <Link
            to="/books"
            className="w-full block text-center font-Philosopher text-white bg-gradient-to-r from-main to-accent hover:from-mainDark hover:to-accent font-bold rounded-xl text-lg px-6 py-3 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Get Book
          </Link>
        </div>

        {/* 5 Divine Thoughts Card */}
        <div className="group glassmorphism rounded-3xl p-8 flex flex-col justify-between hover:-translate-y-2 hover:shadow-2xl transition duration-500 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-32 h-32 bg-accent/10 rounded-full blur-2xl pointer-events-none transition duration-500 group-hover:bg-accent/20"></div>
          <div>
            <h3 className="text-2xl text-center font-bold font-Philosopher text-heads mb-8">
              5 दिव्य विचार <br />
              <span className="text-xl text-heads/60 font-normal">
                (5 Divine Thoughts)
              </span>
            </h3>

            <div className="space-y-4 mb-8">
              {[
                { hi: "१. नियम", en: "Rules" },
                { hi: "२. कृपा", en: "Grace" },
                { hi: "३. तत्त्व ज्ञान", en: "Philosophy" },
                { hi: "४. सेवा", en: "Service" },
                { hi: "५. तीर्थ", en: "Pilgrimage" },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex justify-between items-center px-4 py-2 bg-bgWarm rounded-lg border border-heads/5"
                >
                  <span className="font-bold text-accent">{item.hi}</span>
                  <span className="text-sm text-heads/60">{item.en}</span>
                </div>
              ))}
            </div>
          </div>
          <Link
            to="/5-divine-thoughts"
            className="w-full block text-center font-Philosopher text-white bg-gradient-to-r from-main to-accent hover:from-mainDark hover:to-accent font-bold rounded-xl text-lg px-6 py-3 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Know More
          </Link>
        </div>

        {/* Sandesh Card */}
        <div className="group rounded-3xl p-8 flex flex-col justify-between hover:-translate-y-2 hover:shadow-2xl transition duration-500 overflow-hidden relative md:col-span-2 lg:col-span-1 bg-gradient-to-br from-bgWarm to-[#fdf8f0] border border-main/20 shadow-lg">
          {/* Decorative glowing corners */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-accent/10 rounded-full blur-3xl pointer-events-none transition duration-500 group-hover:bg-accent/20"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-main/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative z-10">
            <div className="flex justify-center mb-4">
              <span className="text-4xl text-accent drop-shadow-sm">📜</span>
            </div>

            <h3 className="text-2xl md:text-3xl text-center font-bold font-Philosopher text-mainDark mb-6 drop-shadow-sm border-b-2 border-main/20 pb-4">
              विजयते श्रीकृष्ण-संकीर्तनम
            </h3>

            <div className="px-2">
              <p className="text-lg font-bold text-accent mb-2 font-Philosopher">
                प्रिय साधको,
              </p>
              <p className="text-base text-heads/85 leading-relaxed mb-6 font-medium text-justify">
                कलियुग में केवल हरिनाम, हरिनाम और हरिनाम से ही उद्धार हो सकता
                है। हरिनाम के अलावा कलियुग में उद्धार का अन्य कोई भी उपाय नहीं
                है!
              </p>

              <div className="bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-white shadow-sm text-center transform transition group-hover:scale-105 duration-500">
                <p className="text-mainDark font-bold italic mb-1 drop-shadow-sm">
                  "हरेर्नाम हरेर्नाम हरेर्नामैव केवलं।"
                </p>
                <p className="text-mainDark font-bold italic drop-shadow-sm">
                  "कलौ नास्त्यैव नास्त्यैव नास्त्यैव गतिरन्यथा।।"
                </p>
              </div>
            </div>
          </div>

          <Link
            to="/sandesh"
            className="relative z-10 w-full block text-center font-Philosopher text-white bg-gradient-to-r from-main to-accent hover:from-mainDark hover:to-accent font-bold rounded-xl text-lg px-6 py-3 transition-all duration-300 shadow-md hover:shadow-lg mt-8"
          >
            Read Full Sandesh
          </Link>
        </div>
      </div>
    </section>
  );
}
